import { useLanguage } from "@/contexts/LanguageContext";
import { PageContainer } from "@/components/flowly/PageContainer/PageContainer";
import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { PricingCards } from "@/components/flowly/PricingCards/PricingCards";

export function PricingPreview() {
  const { t } = useLanguage();
  const { ref, isInView } = useInView();

  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-transparent via-brand/[0.03] to-transparent">
      <PageContainer width="wide">
        <div
          ref={ref}
          className={cn(
            "transition-all duration-700",
            isInView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
          )}
        >
          {/* Header */}
          <div className="text-center mb-12">
            <span className="block text-xs font-semibold tracking-[0.2em] uppercase text-brand mb-3">
              {t.landing.eyebrowPricing}
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
              {t.landing.pricingTitle}
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              {t.landing.pricingSubtitle}
            </p>
          </div>

          {/* Shared Pricing Cards */}
          <PricingCards mode="landing" />

          {/* Compare all plans link */}
          <div className="text-center mt-10">
            <Link
              to="/pricing"
              className="text-sm text-primary hover:text-primary/80 underline underline-offset-4 transition-colors"
            >
              {t.landing.pricingCompareAll}
            </Link>
          </div>
        </div>
      </PageContainer>
    </section>
  );
}
